<template>
	<div>
		<span class="w-100" id="payment_pending_header"></span>
		<div v-if="is_load || is_loading_payment" class="w-100 py-4 text-center">
      <loader />
      <p v-if="is_loading_payment" class="mt-2 body-2-4">Loading payment data..</p>
    </div>
    <template v-else>
    	<div class="px-4" v-if="error != ''">
      	<ErrorMessage :message="error" />
    	</div>
      <template v-else>
      	<!-- PAYMENT SUCCESS -->
      	<div v-if="show_success_data || isHostedPaymentPending" class="w-100 bg-green py-5" style="min-height:100vh;">
      		<div class="px-4 mt-5">
	      		<div class="mx-auto success-icon-rounded-wrap mb-4">
							<div class="mx-auto success-icon-rounded">
							<img v-if="!isHostedPaymentPending" src="../../../assets/img/icon/correct-green.svg" height="50" width="50">
							<img v-else src="../../../assets/img/icon/pending2.png" height="50" width="50">
							</div>
						</div>
						<div class="text-center mb-5">
							<p class="heading-5 text-white mb-2">{{ isHostedPaymentPending ? 'Payment Pending' : $t('hotel.concierge.fitur.successfully-booking') }}</p>
							<p class="body-1-3 text-white">{{ isHostedPaymentPending ? 'Please complete your payment to finalize your booking.' : $t('hotel.concierge.fitur.successfully-booked-a-voucher') }}</p>

              <div v-if="isHostedPaymentPending" class="w-100 bg-white radius-12 p-3 mb-4 cursor-pointer" @click="handlePaymentClick">
                <p class="body-2-1 text-center mb-0 text-green font-bold">Complete Payment</p>
              </div>
						</div>
						<div class="w-100 mb-5 bg-white radius-12 p-3">
							<div class="row no-gutters mb-3 pb-3 border-b-semi-grey cursor-pointer" @click="toggleDetail">
								<div class="col-2 align-self-center">
									<img :src="getMerchant.image_url" class="w-100">
								</div>
								<div class="col-9 align-self-center">
									<div class="px-3">
										<p class="body-1-2 mb-0">{{getMerchant.name}}</p>
										<p class="body-3-3-1 mb-0">{{getTotalVoucher()}} {{$t('hotel.concierge.fitur.vouchers-booked')}}</p>
									</div>
								</div>
								<div class="col-1 align-self-center text-right">
									<i class="iconsmind-Arrow-Right font-weight-bold text-18"></i>
								</div>
							</div>
							<div class="row no-gutters">
								<div class="col-7">
									<p class="body-3-3-1 mb-0">{{$t('hotel.concierge.invoice')}}</p>
									<p class="body-2-1 mb-0">{{original_data.invoice}}</p>
								</div>
								<div class="col-5 text-right">
									<p class="body-3-3-1 mb-0">{{$t('hotel.concierge.total-payment')}}</p>
									<p class="sub-heading-1-2 mb-0">{{$formatCurrency(total_bill)}}</p>
								</div>
							</div>
						</div>
						<div v-if="!is_form_data_complete" class="w-100 bg-danger radius-12 p-3 position-relative" @click="goToFormData()">
							<p class="sub-heading-1-1 text-white mb-2">{{$t('hotel.concierge.fitur.next-step')}}</p>
							<p class="body-2-2-1 text-white mb-2">{{$t('hotel.concierge.fitur.please-complate-voucher')}}</p>
							<p class="py-2 px-3 body-2-1 bg-white text-danger radius-6 mb-0 d-table ml-auto cursor-pointer">{{$t('hotel.concierge.fitur.complete-data')}}</p>
							<i class="text-24 simple-icon-puzzle font-weight-bold text-white position-absolute" style="top:19px; right: 15px;opacity:0.5;"></i>
						</div>
						<p class="d-table mx-auto body-1-3 text-white cursor-pointer mt-4" @click="goToHome()"><u>{{$t('general.back-to-home')}}</u></p>
					</div>
      	</div>

				<template v-else>
					<!-- PAYMENT UNPAID DAN PENDING -->
					<div v-if="payment.status == 'UNPAID' || payment.status == 'PENDING'" class="w-100">
						<div class="px-4 py-5" v-if="payment.status == 'UNPAID'">
							<wrapper-mobile-view>
								<div class="w-100 bg-white py-3 px-4 border-b-semi-grey">
									<div class="w-100">
										<div class="row">
											<div class="col-1 align-self-center" v-if="direct.show">
												<div @click="toggleConfirmDirect" class="d-inline-grid cursor-pointer">
													<img src="../../../assets/img/icon/back.png" alt="Back" class="mt-1" width="20">
												</div>
											</div>
											<div class="col-9 align-self-center">
												<p class="mb-0 body-1-2">{{direct.show?'Confirm your payment':'Payment pending'}}</p>
											</div>
										</div>
									</div>
								</div>
							</wrapper-mobile-view>
							<block :height="10" />

							<template v-if="!direct.show">
								<VirtualAccount
									v-if="payment.payment_channel.payment_method == 'VIRTUAL_ACCOUNT' || payment.payment_channel.payment_method == 'BANK_TRANSFER'"
									:data="payment"
									module_page="HOTEL_UPSELLING"
									:customer_detail="trx.customer_detail" />
								<Qris
									v-if="payment.payment_channel.payment_method == 'QRIS'"
									:data="payment"
									module_page="HOTEL_UPSELLING"
									:customer_detail="trx.customer_detail" />
								<button class="g-btn g-btn-secondary g-btn-lg mb-3 w-100" v-if="payment.payment_channel.bank_name == 'DIRECT_PAYMENT'" @click="toggleConfirmDirect()">Confirm Payment</button>
								<button class="g-btn g-btn-secondary g-btn-lg mb-3 w-100" v-if="isJokulCreditCardPending" :disabled="is_opening_jokul_checkout" @click="openJokulCheckout()">{{$t('hotel.action.continue-payment')}}</button>
								<button class="g-btn g-btn-primary g-btn-lg w-100" @click="loadFirstData()">{{$t('hotel.action.check-payment-status')}}</button>
							</template>

							<!-- CONFIRM PAYMENT FORM -->
							<template v-else>
								<div class="w-100">
									<div class="w-100 mb-3" id="bank_name">
										<p class="mb-1 body-3-1">Bank/E-Wallet Name<span class="text-danger">*</span></p>
										<input
											type="text"
											class="form-control body-2-1"
											v-model="direct.form.bank_name"
											:class="{'border-danger' : direct.validate_form.bank_name != ''}">
										<p class="mb-0 body-3 text-danger mt-1" v-if="direct.validate_form.bank_name != ''">
											{{direct.validate_form.bank_name}}
										</p>
									</div>
									<div class="w-100 mb-3">
										<p class="mb-1 body-3-1">Account Holder<span class="text-danger">*</span></p>
										<input type="text" class="form-control body-2-1" v-model="direct.form.account_name"
											:class="{'border-danger' : direct.validate_form.account_name != ''}">
										<p class="mb-0 body-3 text-danger mt-1" v-if="direct.validate_form.account_name != ''">
											{{direct.validate_form.account_name}}
										</p>
									</div>
									<div class="w-100 mb-3">
										<p class="mb-1 body-3-1">Account Number<span class="text-danger">*</span></p>
										<input type="text" class="form-control body-2-1" v-model="direct.form.account_number" :class="{'border-danger' : direct.validate_form.account_number != ''}">
										<p class="mb-0 body-3 text-danger mt-1" v-if="direct.validate_form.account_number != ''">
											{{direct.validate_form.account_number}}
										</p>
									</div>
									<div class="w-100 mb-3">
										<p class="mb-2 body-3-1">Transfer Date<span class="text-danger">*</span></p>
										<p v-if="direct.validate_form.tf_date != ''" class="mb-0 body-3 text-danger mt-1">
											{{direct.validate_form.tf_date}}
										</p>
										<div class="row slim-grid-row">
											<div class="col-4">
												<p class="mb-1 body-3-3">Year<span class="text-danger">*</span></p>
												<input type="text" class="form-control body-2-1" v-model="direct.form.payment_date.year" :class="{'border-danger' : direct.validate_form.year != ''}">
												<p class="mb-0 body-3 text-danger mt-1" v-if="direct.validate_form.year != ''">
													{{direct.validate_form.year}}
												</p>
											</div>
											<div class="col-4">
												<p class="mb-1 body-3-3">Month<span class="text-danger">*</span></p>
												<input type="text" class="form-control body-2-1" v-model="direct.form.payment_date.month" :class="{'border-danger' : direct.validate_form.month != ''}">
												<p class="mb-0 body-3 text-danger mt-1" v-if="direct.validate_form.month != ''">
													{{direct.validate_form.month}}
												</p>
											</div>
											<div class="col-4">
												<p class="mb-1 body-3-3">Day<span class="text-danger">*</span></p>
												<input type="text" class="form-control body-2-1" v-model="direct.form.payment_date.day" :class="{'border-danger' : direct.validate_form.day != ''}">
												<p class="mb-0 body-3 text-danger mt-1" v-if="direct.validate_form.day != ''">
													{{direct.validate_form.day}}
												</p>
											</div>
										</div>
									</div>
									<div class="w-100 mb-4">
										<p class="mb-1 body-3-1">Transfer Receipt<span class="text-danger">*</span></p>
										<div class="text-center mb-0" :class="{'border-danger':direct.validate_form.image != ''}">
											<label v-if="direct.form.image.original == null" class="w-100 cursor-pointer" for="file_image">
												<div class="w-100 bg-light-page py-4 border-2-dashed rounded-6 cursor-pointer" style="box-shadow: 4px 3px 4px 0px #ccccccba;">
													<img src="../../../assets/img/icon/ar-camera-light.png" width="40">
													<p class="mb-0 pt-1 body-1 text-14 font-bold text-center">{{$t('hotel.action.choose-photo')}}</p>
													<input type="file" ref="file_upload" accept="image/png, image/jpeg, image/jpg" id="file_image" class="d-none" @change="pushImage" />
												</div>
											</label>
											<div class="w-100 bg-light-page border rounded-6 position-relative" v-else style="box-shadow: 4px 3px 4px 0px #ccccccba;">
												<div class="rounded-3 bg-back cursor-pointer position-absolute m-2" @click="resetImage" style="z-index: 1049;right: 0">
													<img src="../../../assets/img/icon/cancel.png" class="p-2" width="30">
												</div>
												<img :src="direct.form.image.preview" class="rounded-6 w-100 object-fit" style="height: 190px">
											</div>
										</div>
										<p class="mb-0 body-3 text-danger mt-1" v-if="direct.validate_form.image != ''">
											{{direct.validate_form.image}}
										</p>
									</div>

									<div class="row">
										<div class="col-4">
											<button class="g-btn g-btn-light g-btn-lg mb-3 w-100" @click="toggleConfirmDirect()">Cancel</button>
										</div>
										<div class="col-8">
											<state-button :click="SubmitConfirmPayment" size="lg" block>Confirm</state-button>
										</div>
									</div>
								</div>
							</template>
						</div>
						<template v-else>
							<div class="w-100 px-4 py-5 bg-orange-soft mb-4 text-center">
								<img :src="(isFlywirePayment || isCommercePay) ? require('../../../assets/img/icon/pending2.png') : require('../../../assets/img/icon/pending.png')" width="100" class="position-relative mx-auto mb-4">
								<p class="font-bold mb-3 text-16 text-orange py-2 px-4 bg-white mx-auto d-table" style="border-radius:19px;">{{ isHostedPaymentPending ? 'Payment Pending' : 'Waiting Confirmation' }}</p>
								<p class="font-bold mb-3 text-16 text-white w-100 px-3">{{ isHostedPaymentPending ? 'Please complete your payment to finalize the booking.' : 'Please wait, your booking is being checked' }}</p>
                <button v-if="isHostedPaymentPending" class="g-btn g-btn-primary g-btn-md px-4 mx-auto mb-3" @click="handlePaymentClick">Complete Payment</button>
							</div>
							<div class="px-4">
								<div class="w-100 mb-4 bg-white radius-12 p-3 border-semi-grey">
									<div class="row no-gutters mb-3 pb-3 border-b-semi-grey cursor-pointer" @click="toggleDetail">
										<div class="col-2 align-self-center">
											<img :src="getMerchant.image_url" class="w-100">
										</div>
										<div class="col-9 align-self-center">
											<div class="px-3">
												<p class="body-1-2 mb-0">{{getMerchant.name}}</p>
												<p class="body-3-3-1 mb-0">{{getTotalVoucher()}} {{$t('hotel.concierge.fitur.vouchers-booked')}}</p>
											</div>
										</div>
										<div class="col-1 align-self-center text-right">
											<i class="iconsmind-Arrow-Right font-weight-bold text-18"></i>
										</div>
									</div>
									<div class="row no-gutters">
										<div class="col-7">
											<p class="body-3-3-1 mb-0">{{$t("general.payment-method")}}</p>
											<p class="body-2-1 mb-0">{{payment.payment_channel.name}}</p>
										</div>
										<div class="col-5 text-right">
											<p class="body-3-3-1 mb-0">{{$t('general.payment-method')}}</p>
											<p class="sub-heading-1-2 mb-0">{{$formatCurrency(payment.total_paid)}}</p>
										</div>
									</div>
								</div>
								<button v-if="!isHostedPaymentPending" class="g-btn g-btn-primary g-btn-lg w-100" @click="loadFirstData()">{{$t('hotel.action.check-payment-status')}}</button>
							</div>
						</template>
					</div>

					<!-- PAYMENT FAILED -->
					<div v-if="payment.status == 'CANCELLED'" class="w-100 py-5">
						<div class="px-4">
							<div class="mx-auto failed-icon-rounded-wrap mb-4">
								<div class="mx-auto failed-icon-rounded">
								<img src="../../../assets/img/icon/close-white.png" height="50" width="50">
								</div>
							</div>
							<div class="text-center mb-5">
								<p class="heading-5 text-danger mb-2">{{$t('general.payment-failed')}}</p>
								<p class="body-1-3 mb-0">{{$t("hotel.concierge.fitur.your-transaction-has-failed")}}</p>
							</div>

							<!-- JOKUL CC -->
							<template v-if="payment.payment_channel.bank_name == 'JOKUL_DOKU' && payment.payment_channel.payment_method == 'CREDIT_CARD'">
								<p class="body-3-3-1 mb-1">{{$t('hotel.concierge.fitur.detail-error')}}</p>
								<table class="table table-bordered">
									<tbody>
										<tr>
											<td class="body-3-3-1">{{$t('general.payment-method')}}</td>
											<td class="body-3-3-2">{{payment.payment_channel.name}}</td>
										</tr>
										<tr>
											<td class="body-3-3-1">{{$t("hotel.concierge.fitur.masked-card-number")}}</td>
											<td class="body-3-3-2">{{payment_detail_error.card_payment.masked_card_number}}</td>
										</tr>
										<tr>
											<td class="body-3-3-1">{{$t("hotel.concierge.fitur.response-code")}}</td>
											<td class="body-3-3-2">{{payment_detail_error.card_payment.response_code}}</td>
										</tr>
										<tr>
											<td class="body-3-3-1">{{$t("hotel.concierge.fitur.response-message")}}</td>
											<td class="body-3-3-2">{{payment_detail_error.card_payment.response_message}}</td>
										</tr>
										<tr>
											<td class="body-3-3-1">{{$t("hotel.concierge.fitur.issuer")}}</td>
											<td class="body-3-3-2">{{payment_detail_error.card_payment.issuer}}</td>
										</tr>
									</tbody>
								</table>
							</template>
						</div>
					</div>
				</template>


      	<!-- DETAIL TRX -->
      	<popup-detail
	      	id_ref="success_trx"
		    	direction="bottom"
		    	:show="show_detail_popup"
		    	title="Detail Transaction"
		    	wrapper_size="mobile"
		    	use_max_size
		    	@close="toggleDetail">
		    	<template v-slot:body>
    				<div class="px-4">
    					<!-- VOUCHER LIST -->
    					<div class="w-100">
    						<div class="row">
    							<div class="col-6 mb-4">
    								<p class="body-3-3-1 mb-0">{{$t("hotel.concierge.invoice")}}</p>
										<p class="body-2-1 mb-0">{{original_data.invoice}}</p>
    							</div>
    							<div class="col-6 mb-4">
    								<p class="body-3-3-1 mb-0">{{$t("hotel.success.transaction-date")}}</p>
										<p class="body-2-1 mb-0">{{$formatDateTime(original_data.created_at)}}</p>
    							</div>
    							<div class="col-12 mb-4">
    								<p class="body-3-3-1 mb-1">{{$t("hotel.concierge.fitur.booked-voucher")}}</p>
    								<div class="w-100 p-3 border-semi-grey radius-6">
		  								<div class="row no-gutters" v-for="(voucher,index) in trx.tx_detail_list" :class="{'border-b-semi-grey-dashed mb-3 pb-3': index+1 < trx.tx_detail_list.length}">
		  									<div class="col-2 align-self-center">
		  										<img :src="voucher.product_image" class="w-100 radius-6">
		  									</div>
		  									<div class="col-10 align-self-center">
		  										<div class="pl-3">
			  										<p class="body-2-1 mb-0">{{voucher.product_name}}</p>
			  										<div class="w-100 no-ws">
			  											<p class="body-2 mb-0 d-inline-block align-middle mr-2">{{voucher.qty}}X</p>
			  											<p class="body-2 mb-0 d-inline-block align-middle text-orange">{{$formatCurrency(voucher.subtotal_sell)}}</p>
			  										</div>
			  									</div>
		  									</div>
		  								</div>
		  							</div>
    							</div>
    							<div class="col-12 mb-4">
    								<p class="body-3-3-1 mb-1">{{$t("hotel.concierge.fitur.notes")}}</p>
    								<div class="w-100 p-3 border-semi-grey radius-6">
    									<p class="body-2-1 mb-0">{{original_data.notes == '' ? '-' : original_data.notes}}</p>
    								</div>
    							</div>
									<div class="col-12 mb-4">
    								<p class="body-3-3-1 mb-1">Payment</p>
    								<div class="w-100 p-3 border-semi-grey radius-6">
    									<p class="body-2-1 mb-0" v-if="payment.status == 'PAY_LATER'">Pay at hotel</p>
											<template v-else>
												<div class="row">
													<div class="col-6">
														<p class="mb-0 body-2-2">Payment method</p>
													</div>
													<div class="col-6">
														<p class="mb-0 body-2-4 text-right w-100">{{payment.payment_channel.name}}</p>
													</div>
													<div class="col-12">
														<div class="w-100 border-b-semi-grey-dashed my-3"></div>
													</div>
													<div class="col-6">
														<p class="mb-0 body-2-2">Payment time</p>
													</div>
													<div class="col-6">
														<p class="mb-0 body-2-4 text-right w-100">{{$formatDateTime(payment.created_at)}}</p>
													</div>
													<div class="col-12">
														<div class="w-100 border-b-semi-grey-dashed my-3"></div>
													</div>
													<div class="col-6">
														<p class="mb-0 body-2-2">Status</p>
													</div>
													<div class="col-6">
														<p class="mb-0 body-2-4 text-right w-100" :class="payment.status == 'SUCCESS'?'text-success':'text-danger'">{{payment.status}}</p>
													</div>
												</div>
											</template>
    								</div>
    							</div>
    							<div class="col-12 mb-3">
    								<p class="body-3-3-1 mb-1">{{$t("hotel.concierge.price-detail")}}</p>
    								<div class="w-100 p-3 border-semi-grey radius-6">
    									<div class="row mb-3">
    										<div class="col-5 align-self-center">
    											<p class="body-2-1 mb-0">{{$t("hotel.concierge.fitur.sub-total")}}</p>
    										</div>
    										<div class="col-7 align-self-center text-right">
    											<p class="body-2-1 mb-0">{{$formatCurrency(original_data.total_amount)}}</p>
    										</div>
    									</div>
    									<div class="row mb-3" :class="{'pb-3 border-b-semi-grey-dashed':payment_surcharge > 0}">
    										<div class="col-5 align-self-center">
    											<p class="body-2-1 mb-0">{{$t("hotel.concierge.discount")}}</p>
    										</div>
    										<div class="col-7 align-self-center text-right">
    											<p class="body-2-1 mb-0" v-if="original_data.total_discount == '0'">{{$formatCurrency(0)}}</p>
    											<p class="body-2-1 mb-0 text-orange">-{{$formatCurrency(original_data.total_amount-original_data.total_payment)}}</p>
    										</div>
    									</div>
    									<div class="row mb-3 pb-3 border-b-semi-grey-dashed" v-if="payment_surcharge > 0">
    										<div class="col-7 align-self-center">
    											<p class="body-2-1 mb-0">{{$t("hotel.payment-surcharge")}}</p>
    										</div>
    										<div class="col-5 align-self-center text-right">
    											<p class="body-2-1 mb-0">{{$formatCurrency(payment_surcharge)}}</p>
    										</div>
    									</div>
    									<div class="row">
    										<div class="col-5 align-self-center">
    											<p class="body-1-2 mb-0">{{$t("hotel.concierge.total")}}</p>
    										</div>
    										<div class="col-7 align-self-center text-right">
    											<p class="body-1-2 mb-0">{{$formatCurrency(payment.total_paid)}}</p>
    										</div>
    									</div>
    								</div>
    							</div>
    						</div>
    					</div>
    				</div>
    			</template>
    			<tempalte v-slot:footer>
    				<div class="px-4 pt-3">
    					<button class="ga-btn-primary-lg" @click="goToFormData()">
    						{{$t("hotel.concierge.complete-data")}}
    					</button>
    				</div>
    			</tempalte>
		    </popup-detail>

      </template>
    </template>
	</div>
</template>
<script>
	import {get,post} from '@/services/index.js'
	import {mapGetters} from 'vuex'
	import moment from 'moment'
	import VirtualAccount from '@/components/general/payment/VirtualAccount'
	import Qris from '@/components/general/payment/Qris'
	import { validationMixin } from "vuelidate";
	const { numeric } = require("vuelidate/lib/validators");

	export default{
		components:{
			VirtualAccount,
			Qris
		},
		data(){
			return{
				is_load: true,
				error: '',
				original_data: {},
				trx: {},
				payment: {},
				payment_detail_error: {},
				has_opened_jokul_checkout: false,
				is_opening_jokul_checkout: false,
				show_detail_popup: false,
				countdown: moment(),
	      timeout: false,
	      direct:{
	      	show: false,
	      	form:{
						bank_name: '',
						account_name: '',
						account_number: '',
						payment_date: {
							year: moment().format("YYYY"),
							month: moment().format("MM"),
							day: moment().format("DD"),
						},
						image:{
							original: null,
							preview: null,
							key: 0
						}
					},
					validate_form:{
						bank_name: '',
						account_name: '',
						account_number: '',
						year: '',
						month: '',
						day: '',
						tf_date: '',
						image: ''
					}
	      },
        is_loading_payment: false,
        has_tried_checking_payment: false
      }
		},
		mixins: [validationMixin],
    validations: {
      direct:{
      	form:{
      		payment_date:{
	      		year:{
	      			numeric
	      		},
	      		month:{
	      			numeric
	      		},
	      		day:{
	      			numeric
	      		}
      		}
      	}
      }
    },
		computed:{
			...mapGetters(['getMerchant']),
			isJokulCreditCardPayment(){
				let payment_channel = this.payment.payment_channel
				if(!payment_channel) return false
				return this.$isJokulCreditCard(payment_channel.bank_name, payment_channel.payment_method)
			},
			jokulCheckoutUrl(){
				if(!this.isJokulCreditCardPayment || !this.payment.inq_resp_detail) return ''
				let pg_response = JSON.parse(this.payment.inq_resp_detail)
				return (pg_response.payment && pg_response.payment.url) || ''
			},
			isJokulCreditCardPending(){
				let is_status_pending = this.payment.status == 'UNPAID' || this.payment.status == 'PENDING'
				return is_status_pending && this.isJokulCreditCardPayment && this.jokulCheckoutUrl !== ''
			},
			is_form_data_complete(){
				if(!this.trx.id){
					return false
				}else{
					let checker = true
					for(let vc of this.trx.tx_detail_list){
						if(vc.product_category_code != 'other'){
							if(moment(vc.service_date).isSame(vc.created_at)){
								checker = false
								break;
							}
							if(vc.product_category_code == 'spa'){
								if(this.parsingRemark(vc.remark,'Gender') == '' || this.parsingRemark(vc.remark,'Place') == ''){
									checker = false
									break;
								}
							}
						}
					}
					return checker
				}
			},
			payment_surcharge(){
				let data = 0
				if(this.payment.status && this.payment.status != 'PAY_LATER'){
					data = this.payment.payment_surcharge
				}
				return Number(data)
			},
			total_bill(){
				let data = 0
				if(this.original_data.id){
					data = Number(this.original_data.total_payment)
				}
				if(this.payment_surcharge > 0){
					data += this.payment_surcharge
				}
				return data
			},
			isFlywirePayment() {
        if (!this.payment.payment_channel) return false;
        const { bank_name, payment_method } = this.payment.payment_channel;
        const { status } = this.payment;
        return bank_name === 'FLYWIRE' && payment_method === 'CREDIT_CARD' && (status === 'PENDING' || status === 'UNPAID');
      },
      isRazorpayCurlecPayment() {
        if (!this.payment.payment_channel) return false;
        const { bank_name, payment_method } = this.payment.payment_channel;
        const { status } = this.payment;
        return bank_name === 'RAZORPAY_CURLEC' && (payment_method === 'CREDIT_CARD' || payment_method === 'DIRECT_DEBIT') && (status === 'PENDING' || status === 'UNPAID');
      },
      isCommercePay() {
        if (!this.payment.payment_channel) return false;
        const { bank_name } = this.payment.payment_channel;
        const { status } = this.payment;
        return bank_name === 'COMMERCEPAY' && (status === 'PENDING' || status === 'UNPAID');
      },
      isPivotPayment() {
        if (!this.payment.payment_channel) return false;
        const { bank_name } = this.payment.payment_channel;
        const { status } = this.payment;
        return this.$isPivotPayment(bank_name) && (status === 'PENDING' || status === 'UNPAID');
      },
      isHostedPaymentPending() {
        return this.isFlywirePayment || this.isRazorpayCurlecPayment || this.isCommercePay || this.isPivotPayment;
      },
			show_success_data(){
				let is_payment = this.payment.status
				let is_pay_later = is_payment && this.payment.status == 'PAY_LATER'
				let is_paid = is_payment && this.payment.status == 'SUCCESS'
				return is_pay_later || is_paid || this.isCommercePay || this.isPivotPayment
			},
		},
		mounted(){
			this.loadFirstData()
		},
		methods:{
			goToHome(){
				this.$router.push(`/${this.getMerchant.code}`)
			},
			loadDetailTrx(){
				return new Promise((success,fail)=>{
          const routeQuery = this.$route.query;
          let params = {
            merchant_id: this.getMerchant.id
          }
          if(this.$isNotEmptyV2(routeQuery) && this.$isNotEmptyV2(routeQuery.tx_sk)){
            params.tx_sk = routeQuery.tx_sk
          }
					get('CORE_HOTEL',`merchant-pos/multiple/transaction/${this.$route.params.tx_order_id}`, params).then(response=>{
						let res = response.data
						if(res.success){
							success(res.data)
						}else{
							fail(res.message)
						}
					})
				})
			},
			// Popup Jokul dibuka sekali saja per kunjungan; refetch status tidak boleh membukanya lagi
			autoOpenJokulCheckout(){
				if(!this.isJokulCreditCardPending || this.has_opened_jokul_checkout) return
				this.has_opened_jokul_checkout = true
				this.openJokulCheckout()
			},
			openJokulCheckout(){
				this.is_opening_jokul_checkout = true
				this.$openJokulCheckout(this.jokulCheckoutUrl).finally(()=>{
					this.is_opening_jokul_checkout = false
				})
			},
			loadFirstData(){
				this.is_load = true
				this.error = ''
				this.loadDetailTrx()
				.then(response=>{
					this.original_data = response
					this.trx = response.tx_order_list[0]
					if(response.tx_bill_list.length>0){
						this.payment = response.tx_bill_list[0]
						if(
							this.payment.status == 'CANCELLED' &&
							this.payment.payment_channel.bank_name == 'JOKUL_DOKU' &&
							this.payment.payment_channel.payment_method == 'CREDIT_CARD'){
							this.payment_detail_error = JSON.parse(response.tx_bill_list[0].pay_resp_detail)
						}else if(
							this.payment.status == 'UNPAID' &&
							this.payment.payment_channel.bank_name == 'JOKUL_DOKU' &&
							this.payment.payment_channel.payment_method == 'VIRTUAL_ACCOUNT'){
							// this.VATimer()
						}
					}else{
						this.payment.status = 'PAY_LATER'
					}
					this.autoOpenJokulCheckout()
				})
				.then(() => {
          if((this.isFlywirePayment || this.isRazorpayCurlecPayment) && !this.has_tried_checking_payment){
            this.has_tried_checking_payment = true
            this.is_loading_payment = true
            setTimeout(() => {
              this.loadFirstData()
              this.is_loading_payment = false
            }, 5000)
          }
        })
				.catch(error=>this.error = error)
				.finally(()=>this.is_load = false)
			},
			parsingRemark(data,index){
      	let split_1 = data.split(", ")
      	let callback = ''
      	for (let split_1_1 of split_1){
      		let split_2 = split_1_1.split(": ")
      		if(split_2[0] == index){
      			callback = split_2[1]
      		}
      	}
      	return callback
      },
			getTotalVoucher(){
				let data_return = 0
				this.trx.tx_detail_list.forEach(voucher=>{
					data_return += voucher.qty
				})
				return data_return
			},
			toggleDetail(){
				this.show_detail_popup = !this.show_detail_popup
			},
			goToFormData(){
				this.$router.push(`/${this.getMerchant.code}/upselling/form-data/${this.$route.params.tx_order_id}`)
			},
			VATimer(){
				let now = moment().add(1,'h')
	      let now_formatted = moment(now).format("YYYY-MM-DD HH:mm:ss")
	      let expired_at_formatted = moment(this.payment.payment_details.expired_date_utc).format("YYYY-MM-DD HH:mm:ss")
	      this.countdown = moment.duration(moment(expired_at_formatted).diff(moment(now_formatted)))

	      let looping = setInterval(() => {
	          this.countdown = this.countdown.subtract(1, 'seconds')
	        if (this.countdown.hours() <= 0 && this.countdown.minutes() <= 0 && this.countdown.seconds() <= 0) {
	          clearInterval(looping)
	          this.timeout = true
	        }
	      },1000)
			},
			toggleConfirmDirect(){
				this.direct.show = !this.direct.show
				if(this.direct.show){
					setTimeout(()=>{
						this.$smoothScroll('payment_pending_header')
					},300)
				}
			},
			pushImage(e) {
        e.preventDefault();
        var files = this.$refs.file_upload.files;
        if (!files.length){
          return;
        }
        this.direct.form.image.original = files[0]
        this.direct.form.image.preview = URL.createObjectURL(this.direct.form.image.original);
        this.direct.form.image.key++
      },
      resetImage(){
      	this.direct.form.image.original = null
        this.direct.form.image.preview = null
      },
      combineDate(){
				let date = moment(`${this.direct.form.payment_date.year}-${this.direct.form.payment_date.month}-${this.direct.form.payment_date.day}`,'YYYY-M-D').format()
				return date
			},
      resetValidateForm(){
      	this.direct.validate_form = {
					bank_name: '',
					account_name: '',
					account_number: '',
					year: '',
					month: '',
					day: '',
					tf_date: '',
					image: ''
				}
      },
      validateForm(){
				return new Promise((success,fail)=>{
					this.resetValidateForm()
					let total_error = 0
					if(this.direct.form.bank_name == ''){
						total_error++
						this.direct.validate_form.bank_name = 'Please input bank/e-wallet name'
					}
					if(this.direct.form.account_name == ''){
						total_error++
						this.direct.validate_form.account_name = 'Please input account holder name'
					}
					if(this.direct.form.account_number == ''){
						total_error++
						this.direct.validate_form.account_number = 'Please input account number'
					}

					let validate_date = {
						year: {
							required: this.direct.form.payment_date.year == '',
							min: this.direct.form.payment_date.year.toString().length != 4,
							non_numeric: this.$v.direct.form.payment_date.year.$invalid
						},
						month: {
							required: this.direct.form.payment_date.month == '',
							min: Number(this.direct.form.payment_date.month) > 12,
							non_numeric: this.$v.direct.form.payment_date.month.$invalid
						},
						date: {
							required: this.direct.form.payment_date.day == '',
							min: Number(this.direct.form.payment_date.day) > 31,
							non_numeric: this.$v.direct.form.payment_date.day.$invalid
						}
					}

					if(validate_date.year.required || validate_date.year.min || validate_date.year.non_numeric){
						total_error++
						this.direct.validate_form.year = validate_date.year.non_numeric ? this.$t('affiliate.validation.please-input-year-in-numbers') : this.$t('affiliate.validation.please-input-valid-year')
					}
					if(validate_date.month.required || validate_date.month.min || validate_date.month.non_numeric){
						total_error++
						this.direct.validate_form.month = validate_date.month.non_numeric ? this.$t('affiliate.validation.please-input-month-in-numbers') : this.$t('affiliate.validation.please-input-valid-month')
					}
					if(validate_date.date.required || validate_date.date.min || validate_date.date.non_numeric){
						total_error++
						this.direct.validate_form.day = this.$t('affiliate.validation.please-input-valid-date')
					}

					let invalid_date = (!validate_date.year.required && !validate_date.year.min && !validate_date.year.non_numeric && !validate_date.month.required && !validate_date.month.min && !validate_date.month.non_numeric && !validate_date.date.required && !validate_date.date.min && !validate_date.date.non_numeric) && this.combineDate() == 'Invalid date'

					if(invalid_date){
						total_error++
						this.direct.validate_form.tf_date = this.$t('affiliate.validation.invalid-date-please-ensure-that-the-date-is-correct-exists')
					}
					if(this.direct.form.image.original == null){
						total_error++
						this.direct.validate_form.image = 'Please upload transfer receipt'
					}

					if(total_error > 0){
						fail()
					}else{
						success()
					}
				})
			},
      SubmitConfirmPayment(){
      	return new Promise((success,fail)=>{
      		this.validateForm().then(()=>{
      			this.$compressImage(this.direct.form.image.original).then(compressResult=>{
      				let img_data = compressResult != false ? compressResult : null
      				let fd = new FormData()
			        fd.append("payment_invoice", img_data, img_data.name)
			        fd.append("merchant_id", this.getMerchant.id)
			        fd.append("bank_name", this.direct.form.bank_name)
			        fd.append("account_name", this.direct.form.account_name)
			        fd.append("account_number", this.direct.form.account_number)
			        fd.append("payment_date", moment(this.combineDate()).format("YYYY-MM-DD"))

			        post("CORE_HOTEL",`merchant-pos/transaction/${this.$route.params.tx_order_id}/payment-confirmation`,fd).then(response=>{
		            let res = response.data
		            if(res.success){
		            	this.loadFirstData()
		            	this.toggleConfirmDirect()
		            	success(res.message)
		            }else{
			            fail(res.message)
		            }
		          })
		        })
      		}).catch(()=>{
      			console.log(this.direct.validate_form)
      			this.$smoothScroll("payment_pending_header")
      			fail("Incomplete form")
      		})
      	})
      },
      handlePaymentClick(){
        const pg_response = JSON.parse(this.payment.inq_resp_detail);
        const { channel, ch_ref1: code } = this.payment.payment_channel;

        if(this.isFlywirePayment){
          this.$submitPaymentFlywire({
            ...pg_response.payment,
            tx_order_id: this.$route.params.tx_order_id
          }, true, 'VOUCHER').finally(() => {
            this.loadFirstData()
          })
        } else if (this.isRazorpayCurlecPayment) {
          this.$submitPaymentRazorpay({
            ...pg_response.payment,
            tx_order_id: this.$route.params.tx_order_id,
            payment_config:{ channel, code }
          }, true, 'VOUCHER').finally(() => {
            this.loadFirstData()
          })
        } else if(this.isCommercePay){
          this.$openLink(pg_response.payment.commercepay_payment_url)
        } else if(this.isPivotPayment){
          this.$openLink(this.$getPivotPaymentUrl(pg_response))
        } else {
          this.loadFirstData()
        }
      }
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/hotel/upselling/GroupVoucherBookingResult.vue